import { render, staticRenderFns } from "./TwilioStatusBadge.vue?vue&type=template&id=43bd0dd2&scoped=true&"
import script from "./TwilioStatusBadge.vue?vue&type=script&lang=js&"
export * from "./TwilioStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./TwilioStatusBadge.vue?vue&type=style&index=0&id=43bd0dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bd0dd2",
  null
  
)

export default component.exports